import { useEffect } from 'react';
import { type IFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { Layer } from '../..';
import { LayerHotkeyType } from '../../type';

export function useCloneHotkey(framework: IFramework) {
    useEffect(() => {
        const { $t } = getLocaleStore();
        const controller = new Layer(framework.identity);

        framework.service.hotkey.register({
            name: $t((v) => v.Text_CreateCopy),
            win: 'Ctrl D',
            mac: '⌘ D',
            key: LayerHotkeyType.CLONE,
            processors: [
                {
                    press: ['Ctrl+D', 'Command+D'],
                    fn: () => {
                        const activeInfo = framework.service.frame.getActiveInfo();
                        const layerId = activeInfo?.info.pickId || activeInfo?.info.id;
                        if (layerId) {
                            controller.resetPreAddLayerId(layerId);
                            controller.clone(layerId);
                        }
                    },
                },
            ],
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps -- 仅挂载时注册，与拆分前一致
    }, []);
}
